module.exports = __webpack_public_path__ + "img/怪盜.jpg";